<script context="module">
  export const prerender = true
</script>

<script>
  import { PixelatedContainer } from '$lib/components/containers'
</script>

<svelte:head>
  <title>Nuzlocke Tracker | Terms of Service</title>
  <meta name="robots" content="noindex, nofollow" />
</svelte:head>

<main class='container mx-auto text-gray-800 pb-24 pt-8 sm:pt-0 dark:text-gray-300'>
  <div class='mx-auto pb-16 sm:pb-12 mx-4'>
    <PixelatedContainer className='my-16 py-6 px-8 overflow-x-hidden mx-auto max-w-prose'>
      <h1 class='text-2xl'>Terms of Service</h1>
      <p class='text-xs -mt-px'>Last updated: October 5, 2026</p>

      <p>
        By using the <b>Pokémon Nuzlocke Tracker</b>, you agree to these terms.
        If you do not agree, please do not use this application.
      </p>

      <h2 class='text-xl mb-2'>Use of Service</h2>
      <p>
        This is a free tool for tracking Pokémon Nuzlocke challenge runs.
        Your game data and preferences are stored only in your browser's local storage.
        We do not provide user accounts or server-side save storage.
        We do not guarantee data persistence or recovery;
        please <a href='/saves'>export backups of your saves</a> regularly.
      </p>
      <p>
        Transfer links and QR codes contain a copy of your save that anyone
        with the link can access. Share them only with people you trust, and
        avoid including personal or sensitive information. Deleting a local
        save does not remove copies you have already shared or exported.
      </p>

      <h2 class='text-xl mb-2'>Privacy and Analytics</h2>
      <p>
        Google Analytics 4 and Google AdSense are the only analytics and
        advertising services we use to collect information. Our
        <a href='/privacy-policy'>Privacy Policy</a> explains local browser storage,
        the information collected through these Google services, and your
        privacy choices. Agreement to these terms does not replace
        any consent required for optional cookies or personal-data processing.
      </p>

      <h2 class='text-xl mb-2'>Advertising and Third-Party Services</h2>
      <p>
        Google AdSense advertisements help support this free service.
        The appearance of an advertisement does not mean we endorse the
        advertiser or its products. Third-party websites and services have
        their own terms and privacy policies; review those before providing
        information or making a purchase. We do not control their content,
        availability, or practices.
      </p>

      <h2 class='text-xl mb-2'>Disclaimer</h2>
      <p>
        Pokémon and all related media are trademarks of Nintendo, Game Freak, and The Pokémon Company.
        This is a fan-made project and is not affiliated with, endorsed by, or sponsored by these companies.
      </p>

      <h2 class='text-xl mb-2'>Limitation of Liability</h2>
      <p>
        To the extent permitted by applicable law, we provide this service
        "as is" and "as available" without warranties. We do not guarantee
        uninterrupted access or the accuracy of game data and recommendations.
        To the extent permitted by law, we are not liable for lost save data,
        gameplay decisions, or damages arising from use of this tool.
        Nothing in these terms limits rights or liabilities that cannot
        lawfully be limited or excluded.
      </p>

      <h2 class='text-xl mb-2'>Changes to Terms</h2>
      <p>
        We may update these terms and will post the revised version and date
        on this page. Changes take effect when posted unless a later date is
        stated or applicable law requires otherwise. Where required, we will
        provide additional notice. Continued use after changes take effect
        constitutes acceptance of the updated terms.
      </p>

      <h2 class='text-xl mb-2'>Contact Us</h2>
      <p>
        For questions about these terms, email
        <a href='mailto:support@nuzlocketracker.org'>support@nuzlocketracker.org</a>.
      </p>
    </PixelatedContainer>
  </div>
</main>

<style lang="postcss">
  h2 { margin-top: 24px; }
  p { margin-bottom: 16px; }
  a { text-decoration: underline; text-underline-offset: 2px; overflow-wrap: anywhere; }
  a:hover { text-decoration-thickness: 2px; }
</style>
